<template>
  <div class="">
    <div>
      <a-table :columns="columns" :data-source="displayDistroCenters" :loading="tableLoading" :pagination="pagination"
        class="tableStyle">
        <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
          style="padding: 8px">
          <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
            :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
            Search
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
            Reset
          </a-button>
        </div>
        <template slot="action" slot-scope="data">
          <a-dropdown>
            <a style="color: #98c14b" class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              <a-icon style="font-size: 25px" type="ellipsis" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="showMoreDetails(data)">More Details</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="update(data)">Update Details</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
        <template slot="statusLabel" slot-scope="data">
          <span v-if="data">
            <status-component :status="data"></status-component>
          </span>
          <span v-else>N/A</span>
        </template>

      </a-table>
      <!-- modals -->
      <a-modal class="modalStyle" :visible="showUpdateModal" :footer="null"
        @cancel="showUpdateModal = !showUpdateModal">
        <UpdateDistroCentreModal :distroCentre="selectedCentre" />
      </a-modal>
      <!-- modals -->
    </div>
  </div>
</template>

<script>
import moment from "moment";
import StatusComponent from "@/components/shared-components/StatusComponent.vue";

export default {
  name: "AllDistroCenterTable",
  components: {
    UpdateDistroCentreModal: () =>
      import("@/components/locations/modals/UpdateDistroCenter"),
    StatusComponent
  },
  props: {
    distroCenters: {
      type: Object,
      default: function () {
        return { data: [] };
      },
    },
  },
  data: () => ({
    tableLoading: false,
    selectedCentre: {},
    searchText: '',
    searchInput: null,
    searchedColumn: '',
    pagination: {
      pageSize: 20,
    },
    columns: [
      {
        title: "ID",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "Center Name",
        dataIndex: "name",
        key: "name",
        scopedSlots: {
        filterDropdown: 'filterDropdown',
        filterIcon: 'filterIcon',
        },
        onFilter: (value, record) =>
            record.name
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
      },
      {
        title: "Center Address",
        dataIndex: "address",
        key: "address",
      },
      {
        title: "Created Date",
        dataIndex: "createdAt",
        key: "createdAt",
      },
      {
        title: "Status",
        dataIndex: "statusLabel",
        key: "statusLabel",
        scopedSlots: { customRender: "statusLabel" },
      },
      {
        title: "Action",
        key: "action",
        dataIndex: "action",
        scopedSlots: { customRender: "action" },
      },
    ],
    displayDistroCenters: [],
    showUpdateModal: false,
  }),
  watch: {
    distroCenters: function (newDistroCenters) {
      this.setTableData(newDistroCenters);
    },
  },
  methods: {
    handleSearch(selectedKeys, confirm, dataIndex) {
        confirm();
        this.searchText = selectedKeys[0];
        this.searchedColumn = dataIndex;
    },
    handleReset(clearFilters) {
        clearFilters();
        this.searchText = '';
        // this.loadSalesByCategory()
    },
    showMoreDetails(data) {
      this.$store.commit("distroCenter/SET_SINGLE_DISTROCENTER", data);
      this.$router
        .push({ name: "SingleDistro", params: { distroId: data.id } })
        .catch(() => {});
    },
    setTableData(newDistros) {
      // console.log("new distros", newDistros);
      this.displayDistroCenters = [...newDistros.data];
      this.displayDistroCenters.forEach((center) => {
        center.createdAt = moment(center.createdAt).format("DD-MMM-YYYY");
        center.action = center;
        center.key = center.id + center.name;
      });
    },
    update(data) {
      data['type'] = data.type.toString()
      this.selectedCentre = data;
      this.showUpdateModal = !this.showUpdateModal;
    },
  },
  mounted() {
    this.setTableData(this.distroCenters);
  },
};
</script>

<style scoped>
.requestActions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.card-container {
  background: none;
  overflow: hidden;
  /* padding: 24px; */
}
.card-container > .ant-tabs-card > .ant-tabs-content {
  height: 120px;
  margin-top: -16px;
}

.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}

.card-container
  >>> .ant-tabs.ant-tabs-card
  .ant-tabs-card-bar
  .ant-tabs-tab-active {
  height: 40px;
  color: #98c14b;
  background: #e5efe7;
  border-color: #e5efe7;
  border-bottom: 1px solid #98c14b;
}
.card-container >>> .ant-tabs-tab {
  height: 40px;
  margin: 0;
  width: 217px;
  margin-right: 2px;
  padding: 0 16px;
  line-height: 38px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
}
.card-container >>> .ant-tabs-tab:hover {
  color: #98c14b;
  /* background: #e5efe7; */
}

.modalStyle >>> .ant-modal-header {
  border-bottom: none;
}

.modalStyle >>> .ant-modal-footer {
  border-top: none;
}
.modalStyle {
  display: flex;
  justify-content: center;
}

.card-container >>> .ant-badge-count {
  z-index: auto;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  color: #fff;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  text-align: center;
  background: #98c14b;
  border-radius: 10px;
  box-shadow: 0 0 0 1px #fff;
}

.spinner >>> .ant-spin-dot-item {
  background-color: #418a49;
}

.card-container > .ant-tabs-card > .ant-tabs-bar {
  border-color: #fff;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  border-color: #e5efe7;
  background: #e5efe7;
}

.ant-table-wrapper {
  zoom: 1;
  background: #fff;
  margin-bottom: 30px;
}

button:hover {
  color: #418a49;
  outline-color: #418a49;
  border-color: #418a49;
}
.tableStyle >>> .ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.tableStyle >>> .ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.tableStyle >>> .ant-pagination-item-active a {
  color: #fff;
}
.tableStyle >>> .ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

.tableStyle>>>.ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
  color: #fff;
}

.tableStyle>>>.ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
  background: #26A246;
  color: #fff;

}

.tableStyle>>>.ant-table-thead th {
  background: #fff;
  height: 63px;
}

.tableStyle>>>.ant-table-header {
  background: #fff !important;
}
</style>